module.exports = __webpack_public_path__ + "fonts/icomoon-app.86ddc0e1.woff2";